import { Component, Input, OnInit } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";
import { createFiscalIdentifierMask } from "./model";
import { VuiValidators } from "../directives/mat-input-required.directive";
import { FloatLabelType } from "@angular/material/form-field";

@Component({
    selector: "vui-fiscal-identifier-form-field",
    templateUrl: "./fiscal-identifier-form-field.component.html",
})
export class FiscalIdentifierFormFieldComponent implements OnInit {
    @Input()
    label: string;

    @Input()
    placeholder: string;

    @Input()
    form: FormGroup;

    @Input()
    controlName: string;

    @Input()
    mask: any = createFiscalIdentifierMask();

    @Input()
    autoFocus: boolean;

    required: boolean;

    @Input()
    classes: string[] = [];

    @Input()
    floatLabel: FloatLabelType = "auto";

    constructor() {}

    ngOnInit(): void {
        this.required =
            this.form.get(this.controlName).hasValidator(Validators.required) ||
            this.form.get(this.controlName).hasValidator(VuiValidators.required);
    }
}
